import React from 'react'

export default (
  <div>
    <p>
      <strong>Sua senha deve conter pelo menos:</strong>
    </p>
    <p>- 8 caracteres</p>
    <p>- 1 letra maiúscula</p>
    <p>- 1 letra minúscula</p>
    <p>- 1 número</p>
    <p>- {'1 caracter especial ~ ! # $ * - _ + = ? [ ] ( ) } '}</p>
  </div>
)
